<template>
  <BaseStep
    title="Wie fühlen Sie sich dabei?"
    description="Ihre Gefühle helfen uns, Sie besser zu verstehen. Sie können mehrere Optionen auswählen."
  >
    <div class="space-y-3">
      <SelectableCheckboxCard
        v-for="feeling in feelings"
        :key="feeling.id"
        :id="feeling.id"
        :title="feeling.text"
        :is-selected="modelValue.includes(feeling.id)"
        :data-testid="`feeling-${feeling.id}`"
        @toggle="(id) => toggleFeeling(id)"
      />
    </div>
  </BaseStep>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import BaseStep from './BaseStep.vue';

// Lazy load the SelectableCheckboxCard component
const SelectableCheckboxCard = defineAsyncComponent(() => import('@/components/common/SelectableCheckboxCard.vue'));

export interface Feeling {
  id: string;
  text: string;
}

interface Props {
  modelValue: string[];
  feelings: Feeling[];
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
});

const emit = defineEmits<{
  'update:modelValue': [value: string[]];
}>();

const toggleFeeling = (id: string) => {
  const newFeelings = [...props.modelValue];
  const index = newFeelings.indexOf(id);

  if (index === -1) {
    newFeelings.push(id);
  } else {
    newFeelings.splice(index, 1);
  }

  emit('update:modelValue', newFeelings);
};
</script>
